import { dataReportBookmarkSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconReportBookmarkSolid = /*#__PURE__*/createIcon(dataReportBookmarkSolid)
export default IconReportBookmarkSolid
